module.exports = __webpack_public_path__ + "img/banner2_0.a7f57fe5.jpg";